import { EventFormData } from "./eventSchema/eventRegistrationSchema";

export const defaultEventRegistrationFormValues: EventFormData = {
  drivers: [],

  guests: [],

  children: [],
};
